// Manejo de Errores
export default function handleError(functionName, error) {
  console.error(`Error in ${functionName}: ${error.message}`);
  throw error;
}

// Normaliza el codigo HTTP del error de RTK Query (baseQuery puede exponerlo distinto).
export const statusDeError = (e) =>
  e?.status ?? e?.originalStatus ?? e?.data?.statusCode ?? null;

// Mensaje legible del backend, con fallback de la UI.
export const mensajeDeError = (e, fallback) =>
  e?.data?.message || e?.data?.error || e?.error || fallback;
